import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
    rightSide: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        flexDirection: "column",
        height: "406px",
        letterSpacing: 0,
        color: "#000",
    },
    dontShowContainer: {
        display: "flex",
        justifyContent: "flex-start",
        alignitems: "center",
        marginBottom: 26,
        [theme.breakpoints.down("desktop")]: {
            marginTop: 28,
        },
    },
    checkboxContainer: {
        marginRight: 12,
        transform: "translateY(-3px)",
    },
    mobile_rightSide: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        flexDirection: "column",
        letterSpacing: 0,
        color: "#000",
        height: "calc(100vh - 62px)",
        width: "calc(100vw - 50px);",
    },

    mobile_box: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        flexDirection: "column",
    },

    title: {
        fontSize: "35px",
        marginTop: "24px",
        marginBottom: "32px",
    },

    mobile_title: {
        color: "#353535",
        fontSize: "20px",
        fontWeight: 500,
        marginTop: "48px",
        marginBottom: "8px",
    },

    subTitle: {
        fontSize: "20px",
        marginBottom: "130px",
    },

    mobile_subTitle: {
        fontSize: "18px",
        marginBottom: "24px",
    },

    dontShow_container: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "183px",
        marginBottom: "28px",
    },

    buttons_container: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "496px",
    },

    mobile_buttons_container: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        flexDirection: "column",
        width: "100%",
    },

    mobile_noThanks: {
        marginTop: "24px",
    },
}));

export default useStyles;
